import {
  DEFAULT_MERGE_MODE,
  DEFAULT_MIN_PAID_ADS,
  MAX_MIN_PAID_ADS,
  MAP_CAROUSEL_MERGE_MODES,
  MERGE_MODE_GLOBAL_THEN_PAID,
  MERGE_MODE_PAID_ONLY_THRESHOLD,
  MERGE_MODE_PAID_THEN_GLOBAL,
} from "./mapCarouselConstants";

/**
 * @param {unknown} raw
 * @returns {{ mergeMode: string, minPaidAds: number }}
 */
export function normalizeMergeSettings(raw) {
  const mergeMode =
    typeof raw?.mergeMode === "string" &&
    MAP_CAROUSEL_MERGE_MODES.includes(raw.mergeMode)
      ? raw.mergeMode
      : DEFAULT_MERGE_MODE;

  let minPaidAds = parseInt(raw?.minPaidAds, 10);
  if (!Number.isFinite(minPaidAds) || minPaidAds < 1) {
    minPaidAds = DEFAULT_MIN_PAID_ADS;
  }
  if (minPaidAds > MAX_MIN_PAID_ADS) {
    minPaidAds = MAX_MIN_PAID_ADS;
  }

  return { mergeMode, minPaidAds };
}

/**
 * @param {{
 *   globalSlides: object[],
 *   paidSlides: object[],
 *   mergeMode: string,
 *   minPaidAds: number,
 * }} args
 * @returns {object[]}
 */
export function computeFinalCarouselSlides({
  globalSlides,
  paidSlides,
  mergeMode,
  minPaidAds,
}) {
  const g = Array.isArray(globalSlides) ? globalSlides : [];
  const p = Array.isArray(paidSlides) ? paidSlides : [];

  if (mergeMode === MERGE_MODE_PAID_ONLY_THRESHOLD) {
    if (p.length >= minPaidAds) {
      return [...p];
    }
    return [...g];
  }

  if (mergeMode === MERGE_MODE_GLOBAL_THEN_PAID) {
    if (p.length > 0) {
      return [...g, ...p];
    }
    return [...g];
  }

  if (mergeMode === MERGE_MODE_PAID_THEN_GLOBAL) {
    if (p.length > 0) {
      return [...p, ...g];
    }
    return [...g];
  }

  if (p.length >= minPaidAds) {
    return [...p];
  }
  return [...g];
}

/**
 * react-slick quirk: duplicate when a single slide.
 * @param {object[]} slides
 * @returns {object[]}
 */
export function duplicateSingleSlideForSlick(slides) {
  if (!Array.isArray(slides) || slides.length !== 1) {
    return slides;
  }
  const one = slides[0];
  return [one, { ...one, __slickDup: true }];
}
